var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-v2"},[_c('BreadcrumbV2',{attrs:{"items":_vm.breadcrumbItems}}),_c('article',{staticClass:"article-v2"},[_c('h1',[_vm._v(_vm._s(_vm.news.title))]),_c('div',{staticClass:"article-meta"},[_vm._v(_vm._s(_vm.news.date))]),_c('div',{staticClass:"article-body",domProps:{"innerHTML":_vm._s(_vm.news.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }